var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleType && _vm.currentTestId)?_c('poll-test-result',{attrs:{"locale":_vm.locale,"archive-inactive-tests":_vm.archiveInactiveTests,"poll-chain":_vm.pollChain,"test-results":_vm.testResults,"module-type":_vm.moduleType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }